export const AdExtensionAssociation = {
  properties: {
    Type: {
      'bulk-upload-header': 'Type',
      'bulk-upload-mapper': function (value) {
        if (value === 'CampaignDisclaimerAdExtension') {
          return 'Campaign Disclaimer Ad Extension';
        }
        return value;
      },
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
  },
};
